module.exports = __webpack_public_path__ + "4ab5132d88305e7c97ab33dc847ae2ea.png";